import { window } from './globals'; // opts allows user agent to be overridden for testing

export default function isOldIE() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var navigator = window.navigator || {};
  var userAgent = opts.userAgent || navigator.userAgent || ''; // We only care about older versions of IE (IE 11 and below). Newer versions of IE (Edge)
  // have much better web standards support.

  var isMSIE = userAgent.indexOf('MSIE ') !== -1;
  var isTrident = userAgent.indexOf('Trident/') !== -1;
  return isMSIE || isTrident;
}
//# sourceMappingURL=is-old-ie.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/utils/is-old-ie.js
// module id = 1596
// module chunks = 0